import React from "react";
import { Doughnut } from "react-chartjs-2";

import { Box, Card, CardContent, Typography } from "@material-ui/core";

export const OpenAlertsPie = ({ data, origin, statusData, riskData, home }) => {
  let data1 = [];
  if (origin === "Covid") {
    data1 = {
      datasets: [
        {
          data: [data[0].value, data[1].value],
          backgroundColor: ["#f44336", "#e67e22"],
          borderWidth: 8,
          borderColor: "white",
          hoverBorderColor: "white",
        },
      ],
      labels: ["% Ποσοστό Covid", "% Υπόλοιποι Ωφελούμενοι"],
      text: "23%",
    };
  } else {
    data1 = {
      datasets: [
        {
          data:
            (statusData && home === true
              ? [statusData[0].value, statusData[1].value]
              : statusData && [
                  statusData[0].value,
                  statusData[1].value,
                  statusData[2].value,
                ]) ||
            (riskData && [
              riskData[0].value,
              riskData[1].value,
              riskData[2].value,
            ]) ||
            (data && [data[0].value, data[1].value, data[2].value]),
          backgroundColor: ["#f1c40f", "#e67e22", "#f44336"],
          borderWidth: 8,
          borderColor: "white",
          hoverBorderColor: "white",
        },
      ],
      labels:
        (statusData && home === true
          ? [statusData[0].label, statusData[1].label]
          : statusData && [
              statusData[0].label,
              statusData[1].label,
              statusData[2].label,
            ]) ||
        (riskData && [
          riskData[0].label,
          riskData[1].label,
          riskData[2].label,
        ]) ||
        (data && [data[0].label, data[1].label, data[2].label]),
    };
  }

  const options = {
    animation: false,
    cutoutPercentage: 80,
    layout: { padding: 0 },
    legend: {
      display: true,
    },
    maintainAspectRatio: false,
    responsive: true,
  };

  if (statusData || riskData || data) {
    return (
      <Card>
        <CardContent>
          <Box height={300} position="relative">
            <Doughnut data={data1} options={options} />
          </Box>
          <Box display="flex" justifyContent="center" mt={2}>
            {origin != "Covid" && statusData
              ? statusData.map(({ id, label, color, value }) => (
                  <Box key={id} p={1} textAlign="center">
                    {home === true && label === "Κλειστά" ? null : (
                      <Typography color="textPrimary" variant="body1">
                        {label}
                      </Typography>
                    )}
                    {home === true && label === "Κλειστά" ? null : (
                      <Typography style={{ color }}>
                        {home === true
                          ? (
                              (value /
                                (statusData[0].value + statusData[1].value)) *
                              100
                            ).toFixed(2)
                          : (
                              (value /
                                (statusData[0].value +
                                  statusData[1].value +
                                  statusData[2].value)) *
                              100
                            ).toFixed(2)}
                        %
                      </Typography>
                    )}
                  </Box>
                ))
              : origin != "Covid" && riskData
              ? riskData.map(({ id, label, color, value }) => (
                  <Box key={id} p={1} textAlign="center">
                    <Typography color="textPrimary" variant="body1">
                      {label}
                    </Typography>
                    <Typography style={{ color }}>
                      {(
                        (value /
                          (riskData[0].value +
                            riskData[1].value +
                            riskData[2].value)) *
                        100
                      ).toFixed(2)}
                      %
                    </Typography>
                  </Box>
                ))
              : origin != "Covid" && data
              ? data.map(({ id, label, color, value }) => (
                  <Box key={id} p={1} textAlign="center">
                    <Typography color="textPrimary" variant="body1">
                      {label}
                    </Typography>
                    <Typography style={{ color }}>
                      {(
                        (value /
                          (data[0].value + data[1].value + data[2].value)) *
                        100
                      ).toFixed(2)}
                      %
                    </Typography>
                  </Box>
                ))
              : null}
            {origin === "Covid" &&
              data.map(({ id, label2, color, value }) => (
                <Box key={id} p={1} textAlign="center">
                  <Typography color="textPrimary" variant="body1">
                    {label2}
                  </Typography>
                  <Typography style={{ color }} variant="h2">
                    {value}%
                  </Typography>
                </Box>
              ))}
          </Box>
        </CardContent>
      </Card>
    );
  } else {
    return <h1>Δεν υπάρχουν δεδομένα</h1>;
  }
};
